import React, { memo, useCallback, useMemo } from "react";
import { SingleValue } from "react-select";
import { SimpleSelect, SimpleSelectProps } from "../../selects";
import { Locale, PeriodType, Shortcuts } from "../types";

export type PeriodProps = Omit<SimpleSelectProps<PeriodType>, "onChange" | "isMulti" | "options"> & {
  locale: Locale
  shortcuts: Shortcuts
  allowedPeriods: ReadonlyArray<PeriodType>
  onChange?: ((newValue: (SingleValue<PeriodType>)) => void) | undefined
};

export const Period = memo((
  {
    onChange,
    locale,
    shortcuts,
    allowedPeriods,
    ...props
  }: PeriodProps) => {
  const options: PeriodType[] = useMemo(() => {
    const result: PeriodType[] = [];
    if (allowedPeriods.includes("year")) {
      result.push("year");
    }

    if (allowedPeriods.includes("month")) {
      result.push("month");
    }

    if (allowedPeriods.includes("week")) {
      result.push("week");
    }

    if (allowedPeriods.includes("day")) {
      result.push("day");
    }

    if (allowedPeriods.includes("hour")) {
      result.push("hour");
    }

    if (allowedPeriods.includes("minute")) {
      result.push("minute");
    }

    if (
      allowedPeriods.includes("reboot") &&
      shortcuts &&
      (shortcuts === true || shortcuts.includes("@reboot"))
    ) {
      result.push("reboot");
    }
    return result;
  }, [ allowedPeriods, shortcuts ]);

  const setOptionLabel = useCallback((v: PeriodType) => {
    switch (v) {
      case "year":
        return locale.yearOption || v;
      case "month":
        return locale.monthOption || v;
      case "week":
        return locale.weekOption || v;
      case "day":
        return locale.dayOption || v;
      case "hour":
        return locale.hourOption || v;
      case "minute":
        return locale.minuteOption || v;
      case "reboot":
        return locale.rebootOption || v;
    }
    return "";
  }, [ locale ]);

  return (
    <div>
      {locale.prefixPeriod !== "" && (
        <span>{locale.prefixPeriod}</span>
      )}

      <SimpleSelect
        getOptionLabel={setOptionLabel}
        {...props}
        onChange={onChange as any}
        options={options}
        isMulti={false}
      />
    </div>
  );
});